import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Ticker } from "@/components/site/Ticker";
import { Manifesto } from "@/components/site/Manifesto";
import { Tutors } from "@/components/site/Tutors";
import { Method } from "@/components/site/Method";
import { Reviews } from "@/components/site/Reviews";
import { Pricing } from "@/components/site/Pricing";
import { Availability } from "@/components/site/Availability";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App bg-bone text-ink">
            <Nav />
            <main>
                <Hero />
                <Ticker />
                <Manifesto />
                <Tutors />
                <Method />
                <Reviews />
                <Pricing />
                <Availability />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
